/* eslint-disable react/destructuring-assignment */
import React from "react"

import { Logger } from "shared/lib/Logger"
import { ErrorPage } from "shared/ui/error-page/ErrorPage"

const CHUNK_RELOAD_KEY = "chunkReloadAttempted"

function isChunkLoadError(error: Error): boolean {
  const msg = error.message
  return (
    msg.includes("Unable to preload") ||
    msg.includes("Failed to fetch dynamically imported module") ||
    msg.includes("error loading dynamically imported module") ||
    msg.includes("Importing a module script failed")
  )
}

export interface ErrorBoundaryProps {
  children: React.ReactNode | React.ReactNode[]
  suppressNotify?: boolean
  locationKey?: string
}

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  { hasError: boolean }
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }

    this.clearError.bind(this)
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidUpdate(prevProps: ErrorBoundaryProps): void {
    if (this.props.locationKey !== prevProps.locationKey) {
      sessionStorage.removeItem(CHUNK_RELOAD_KEY)
      this.setState({ hasError: false })
    }
  }

  componentDidCatch(error: Error) {
    if (isChunkLoadError(error)) {
      if (!sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
        sessionStorage.setItem(CHUNK_RELOAD_KEY, "1")
        window.location.reload()
        return
      }
    }
    Logger.error(error)
  }

  clearError() {
    this.setState({ hasError: false })
  }

  render() {
    return this.state.hasError ? (
      <ErrorPage clearError={() => this.clearError()} />
    ) : (
      this.props.children
    )
  }
}
